module.exports = __webpack_public_path__ + "static/img/logo_zurquipng.81ced98c.png";